


















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Auth } from "aws-amplify";
import { Urls } from "@/Urls";
import { getModule } from 'vuex-module-decorators';
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Decisions from '@/store/modules/Decisions';
import AppTemplateCard from '@/components/apps/AppTemplateCard.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import moment from 'moment';

const decisionsModule = getModule(Decisions);

@Component({
        components: {
          AppTemplateCard,
          CardTitle,
          DescriptionEditor
        }
    })
export default class ExternalDecisionCloning extends Vue {
    @Prop({required: true})
    decisionId!: string;

    @Prop({required: false, type: Boolean})
    includeChoices: boolean;

    @Prop({required: false, type: Boolean})
    includeViewpoints: boolean;

    @Prop({required: false, type: Boolean})
    includeApps: boolean;

    @Prop({required: false, type: Boolean})
    includeLists: boolean;

    @Prop({required: false, type: Boolean})
    includeComments: boolean;

    @Prop({required: false, type: Boolean})
    includeUsers: boolean;

    private isLoading = false;
    private show = false;
    private newDecisionName = "";
    private linkedDecisionsList = [];
    private decisionModel: any;
    private decisionModelDescription = "";

    get cloneProgress() {
        return decisionsModule.cloneDecisionProgress;
    }

    get clonedDecisionTitle() {
      return this.decisionModel.name;
    }

    get headers() {
        return [
            {
              text: "Decision",
              value: 'name',
              width: '30%',
            },
            {
              text: 'Description',
              value: 'description',
              width: '70%',
            },
            {
              text: 'Updated',
              value: 'lastUpdatedTimestamp',
              width: 115,
            },
            {
              text: 'Publisher',
              value: 'publisherName',
              width: 150,
            },
            {
              text: '',
              value: 'actions',
              sortable: false,
              width: 10,
            },
        ];
    }

    mounted() {
        this.initialize();
    }

    private async initialize() {
        try {
            let authUser = await Auth.currentUserInfo();
            this.isLoading = true;

            // check if user is authorized
            // if yes - start decision cloning process
            // otherwise got to login page and set clone url cookie
            if(!authUser) {
                Vue.$cookies.set('app-clone-url', this.$route.fullPath);
                window.location.href = Urls.VIEWPOINT_HOSTED;
            } else {
                Vue.$cookies.remove('app-clone-url');
                // get Decision model
                let decisionModel = await VIEWPOINT_API.getDecision(this.decisionId);
                this.decisionModelDescription = decisionModel.description;
                this.decisionModel = decisionModel;
                // get all users decision and filter by decisionTemplateId
                let userDecisions = await VIEWPOINT_API.getUserDecisions()
                userDecisions.forEach((decision) => {
                  if (decision.decisionTemplateId && decision.decisionTemplateId == decisionModel.decisionTemplateId) {
                    this.linkedDecisionsList.push(decision);
                  }
                });

                //show Cloning Decision Dialog
                this.show = true;
                this.isLoading = false;
            }  
        } catch (err) {
            this.isLoading = false;
            console.error(err);
        }
    }

    //Cloning Decision method
    private async clone() {
      try {
        this.isLoading = true;
        this.decisionModel.description = this.decisionModelDescription;
        let clonedDecision = await decisionsModule.copyTemplateIntoNewDecision({
                decision: this.decisionModel,
                newTemplateDecisionId: this.decisionModel.decisionTemplateId ? this.decisionModel.decisionTemplateId : this.decisionModel.decisionId,
                newDecisionName: this.newDecisionName,
                options: {
                        includeChoices: this.includeChoices,
                        includeViewpoints: this.includeViewpoints,
                        includeApps: this.includeApps,
                        includeLists: this.includeLists,
                        includeComments: this.includeComments,
                        includeUsers: this.includeUsers
                    }
                });
      } catch (err) {
            this.isLoading = false;
            console.error(err);
        }
    }

    private formatDate(dateString: string) {
        return moment(dateString).format('YYYY-MM-DD');
    }

    private close() {
      this.show = false;
      this.$router.push(Urls.APP);
    }

    private launchToDecisionClick(decision: any) {
      this.$router.push(`${Urls.APP}?decisionId=${decision.decisionId}`);
    }
}
